import { inject, Injectable } from "@angular/core";
import { Auditor } from "@app/Domain/Models/auditor.model";
import { HttpLanguageService, HttpMenuService } from "@core/services";
import { BehaviorSubject, forkJoin } from "rxjs";
import { SessionStorageService } from "./session-storage.service";

@Injectable({
    providedIn: "root"
})
export class TopBarService {
    private httpMenuService = inject(HttpMenuService);
    private languageService = inject(HttpLanguageService);
    private sessionStorage = inject(SessionStorageService);
    private auditor: Auditor = this.sessionStorage.get("auditor");

    private languagesSubject = new BehaviorSubject<any[]>([]);
    languages$ = this.languagesSubject.asObservable();

    private menusSubject = new BehaviorSubject<any[]>([]);
    menus$ = this.menusSubject.asObservable();

    getDependencies(): void {
        forkJoin([
            this.httpMenuService.GetMenuPerfil(this.auditor.idPerfil, this.auditor.idPais),
            this.languageService.getLanguages()
        ]).subscribe(([menus, languages]) => {
            this.menusSubject.next(menus);
            this.languagesSubject.next(languages);
        });
    }
}
